import { forwardRef } from "react";

export const IconSettings = forwardRef<HTMLElement, { size?: number }>(
  (props, ref) => (
    <span {...props} ref={ref} className="IconSettings">
      <svg
        width={props.size ?? 20}
        height={props.size ?? 20}
        viewBox="0 0 16 16"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>Settings</title>
        <defs>
          <path
            d="M12.0000303,14.625 C10.5502803,14.625 9.3750303,13.44975 9.3750303,12 C9.3750303,10.550325 10.5502803,9.375 12.0000303,9.375 C13.4497803,9.375 14.6250303,10.550325 14.6250303,12 C14.6250303,13.44975 13.4497803,14.625 12.0000303,14.625 Z M17.5717803,12.732075 C17.6032803,12.491325 17.6242803,12.24825 17.6242803,12 C17.6242803,11.751825 17.6032803,11.50875 17.5717803,11.268 L19.1565303,10.0275 C19.2997922,9.91152889 19.3373356,9.70853996 19.2450303,9.549 L17.7450303,6.951 C17.6529701,6.79113788 17.4582327,6.72208885 17.2860303,6.78825 L15.4192803,7.5405 C15.0322803,7.2435 14.6085303,6.99225 14.1517803,6.80325 L13.8705303,4.81575 C13.8410594,4.63394728 13.684206,4.5002726 13.5000303,4.5 L10.5000303,4.5 C10.3125303,4.5 10.1580303,4.63725 10.1295303,4.81575 L9.8482803,6.8025 C9.3907803,6.99225 8.9670303,7.2435 8.5800303,7.5405 L6.7140303,6.78825 C6.54182786,6.72208885 6.34709051,6.79113788 6.2550303,6.951 L4.7550303,9.549 C4.6612803,9.711 4.7025303,9.9135 4.8435303,10.0275 L6.4275303,11.268 C6.3960303,11.508 6.3750303,11.751825 6.3750303,12 C6.3750303,12.24825 6.3960303,12.492075 6.4275303,12.732075 L4.8435303,13.971825 C4.7002984,14.0881395 4.66278636,14.2912767 4.7550303,14.451075 L6.2550303,17.049 C6.3480303,17.211 6.5445303,17.277075 6.7140303,17.21175 L8.5807803,16.4595 C8.9677803,16.7565 9.3915303,17.00775 9.8482803,17.196825 L10.1295303,19.18425 C10.1580303,19.362825 10.3125303,19.5 10.5000303,19.5 L13.5000303,19.5 C13.6867803,19.5 13.8420303,19.362825 13.8705303,19.18425 L14.1517803,17.196825 C14.6077803,17.007075 15.0315303,16.7565 15.4185303,16.458825 L17.2860303,17.21175 C17.4582327,17.2779111 17.6529701,17.2088621 17.7450303,17.049 L19.2450303,14.451075 C19.3372742,14.2912767 19.2997622,14.0881395 19.1565303,13.971825 L17.5717803,12.732075 Z"
            id="path-10"
            fill="#d4d4d4"
          />
        </defs>
        <g id="Icons-(Base)" stroke="none" strokeWidth="1" fillRule="evenodd">
          <g
            id="Icons/Material-Design/settings"
            transform="translate(-4.000000, -4.000000)"
          >
            <mask id="mask-2">
              <use xlinkHref="#path-10" />
            </mask>
            <use id="settings" fillRule="nonzero" xlinkHref="#path-10" />
          </g>
        </g>
      </svg>
    </span>
  ),
);
